module.exports = "/images/medcrum-main.svg?d67567e6c9e419d4ea1a79b9f51f293f";